/* CY Versus (2026-10-17): arms the one-time row reveal. The section gets .is-in the first time a part of it is on screen
   (cy-versus.css rises the rows in sequence and stamps the checks). Reduced motion, or no observer: in at once. */
(function () {
  var still = !('IntersectionObserver' in window) || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var io = still ? null : new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: .12 });
  var arm = function (root) { (root || document).querySelectorAll('[data-cyvs]').forEach(function (el) { if (still) el.classList.add('is-in'); else io.observe(el); }); };
  arm();
  document.addEventListener('shopify:section:load', function (e) { arm(e.target); });
})();
